import { TagViewV2Page } from "fleet/view/device/tag-view-v2";
import { connect } from "react-redux";
import { makeGetAllAsArray, isStoreReady } from "redux-store";
import { getAuthUser } from "redux-store/auth/selectors";
import { getTagFromDevices } from "redux-store/devices/selectors";

const getAllDevicesAsArray = makeGetAllAsArray();

function mapStateToProps(state, props) {
  const { id } = props.match.params || {};
  const storesLoaded = isStoreReady(state.global.devices);
  const devices = getAllDevicesAsArray(state.global.devices);
  const tag = getTagFromDevices(devices, id);

  return {
    storesLoaded,
    tag,
    user: getAuthUser(state),
  };
}

const ConnectedTagViewV2Page = connect(mapStateToProps)(TagViewV2Page);

export { ConnectedTagViewV2Page };
